import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import PaymentSuccess from "./Payment/PaymentSuccess";
import PaymentFailed from "./Payment/PaymentFailed";
import { FormData } from "./NoPaymentCertificate";
import { Certificate } from "./NoPaymentCertificate/Certificate";
import { OfflineIndex } from "./OfflineWebinar";
import OfflinePaymentSuccess from "./OfflineWebinar/Payment/PaymentSuccess";
import OfflinePaymentFailed from "./OfflineWebinar/Payment/PaymentFailed";


const Home = lazy(() => import("./Home/index"));

export const Layout = () => {
  return (
    <>
      <main>
        {/* <Header /> */}
        <Suspense fallback={"loding..."}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/payment-failed" element={<PaymentFailed />} />
            <Route path="/nopayment-form" element={<FormData/>}/>
            <Route path="/certificate-download" element={<Certificate/>}/>
            <Route path="/offline-classes" element={<OfflineIndex/>}/>
            <Route path="/offline-payment-success" element={<OfflinePaymentSuccess/>}/>
            <Route path="/offline-payment-failed" element={<OfflinePaymentFailed/>}/>
         
          </Routes>
        </Suspense>
        {/* <Footer /> */}
      </main>
    </>
  );
};
